import {Injectable} from '@angular/core';
import {BaseRestService} from '../restService/baseRestService';
import {Credit} from '../../classes/rest-classes/Credit';
import CacheService from '../cacheService';
import {RestUserService} from "../restService/restUserService";
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({providedIn: 'root'})

export class LowCreditService extends BaseRestService {

    isCreditLow: boolean = false;
    alertOpen = false;
    availableCredit: number = 0;

    constructor(
        private restUserService: RestUserService, 
        private cacheService: CacheService) {
        super();
    }

    public async getUserCredit(): Promise<number> {
        const item = this.cacheService.getCacheItem<Credit>('User_Credit');

        if (item) {
            const lowAvailableCredit: boolean = item.available < 100;
            this.alertOpen = lowAvailableCredit;
            this.isCreditLow = lowAvailableCredit;
            this.availableCredit = item.available;
            return this.availableCredit;
        }

        try {
            const response = await this.restUserService.getUserCredit().toPromise();
            const clsPiCredit = response.find(credit => credit.company === 3);

            if (!clsPiCredit) {
                this.alertOpen = true;
                this.isCreditLow = true;
                this.availableCredit = 0;
                return 0;
            }

            const lowAvailableCredit: boolean = clsPiCredit.available < 100;
            this.alertOpen = lowAvailableCredit;
            this.isCreditLow = lowAvailableCredit;
            this.availableCredit = clsPiCredit.available;

            const secondsToCache = 5;
            this.cacheService.addOrReplaceCacheItem('User_Credit', clsPiCredit, new Date(Date.now() + secondsToCache * 1000));

            return this.availableCredit;
        } catch (error) {

            if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
                location.href = '/ordering/login';
                return 0;
            }

            this.alertOpen = true;
            this.isCreditLow = true;
            this.availableCredit = 0;
            return 0;
        }
    }
}
